import React from 'react';
import useCurrentUser from '../hooks/useCurrentUser';
import AccountNotActivated from '../components/AccountNotActivated';

const AccountNotActivatedPage = () => {
  const { user, loading, applicationStatus } = useCurrentUser();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-blue-500 border-t-transparent"></div>
          <p className="mt-2 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user || user.role !== 'pending') {
    window.location.href = '/landing';
    return null;
  }

  return (
    <AccountNotActivated
      userEmail={user.email}
      applicationStatus={applicationStatus || user.applicationStatus}
    />
  );
};

export default AccountNotActivatedPage;
